import * as React from 'react';
import cn from 'clsx';
import { Accordion } from '@cian/frontend-e2e-deal-component';
import { ArticleHeading2, useDeviceType, ArticleHeading1 } from '@cian/ui-kit';

import { IAccordionOnClickParams } from '../../utils/useAccordionsBehaviour';
import { IFAQCategoryQuestion } from '../../../../types/promoInfo/faq';

import * as styles from './styles.css';

interface IDealFormButtonProps {
  title: string;
  questions: IFAQCategoryQuestion[];
  accordionsCollectionRef: React.MutableRefObject<(HTMLDivElement | null)[]>;
  onAccordionClick: (params: IAccordionOnClickParams) => void;
  activeAccordeonIndex: number | null;
}

export const FAQModalContent: React.FC<React.PropsWithChildren<IDealFormButtonProps>> = ({
  title,
  questions,
  accordionsCollectionRef,
  onAccordionClick,
  activeAccordeonIndex,
}) => {
  const deviceType = useDeviceType();
  const Heading = deviceType === 'phone' ? ArticleHeading2 : ArticleHeading1;

  return (
    <div className={cn(styles['container'], styles[deviceType])} data-testid="faq-modal">
      <Heading as="h2">{title}</Heading>
      {questions.map((question, index) => {
        const isActive = activeAccordeonIndex === index;

        return (
          <div key={index} ref={ref => (accordionsCollectionRef.current[index] = ref)}>
            <Accordion
              title={question.title}
              open={isActive}
              onClick={() => onAccordionClick({ title: question.title, isActive, index })}
            >
              <div className={styles['accordion-content']}>{question.content}</div>
            </Accordion>
          </div>
        );
      })}
    </div>
  );
};

FAQModalContent.displayName = 'FAQModalContent';
